export default __webpack_public_path__ + "5a620e832d66f90367edac2321f8e4c1.png";